<main class="payment ic-page" *ngIf="content">
    <header class="payment__header">
        <h1 class="payment__header-title">{{ content.title }}</h1>
        <p>{{content.subtitle}}</p>
    </header>

    @if(!this.id) {
    <section class="payment__code">
        <p class="payment__section-title">{{content.provideCode}}</p>

        @if(formGroup) {
        <form [formGroup]="formGroup" class="payment__code-fields">
            <app-form-input #codeFirstInput (focus)="onFocus()" (onPaste)="onPaste($event)" class="payment__code-field"
                [inputId]="'codeFirst'" formControlName="codeFirst" type="text" [placeholder]="'___'"
                [formGroup]="formGroup" [errorList]="[
                    {
                        label: content.requiredError,
                        type: ['required']
                    },
                    {
                        label: content.patternError,
                        type: ['pattern']
                    }
                ]">
            </app-form-input>

            <app-form-input #codeSecondInput class="payment__code-field" [inputId]="'codeSecond'"
                formControlName="codeSecond" type="text" [placeholder]="'___'" [formGroup]="formGroup" [errorList]="[
                      {
                        label: content.requiredError,
                        type: ['required']
                    },
                    {
                        label: content.patternError,
                        type: ['pattern']
                    }
                ]">
            </app-form-input>
        </form>
        }

        <ic-ghost-button [disabled]="formGroup.invalid" [htmlId]="'accept-btn'" [typeHTML]="'button'" [showArrow]="true"
            [width]="160" (click)="onCodeSubmit()">
            <span class="forwardSpan start-btn__label">{{content.acceptButton}}</span>
        </ic-ghost-button>
    </section>
    }

    @if(waitingForData) {
    <div class="payment__spinner">
        <app-loaders [type]="'spinner'" [positionRelative]="true"></app-loaders>
    </div>
    }

    @if(this.fastPayment) {
    <app-fast-payments-table #table id="table" [payment]="fastPayment"></app-fast-payments-table>
    <app-choose-payment-method [showIcTerms]="true" [onlyBlik]="true"
        (submitPaymentMethod)="onSubmit($event)"></app-choose-payment-method>
    }

    <app-loaders fullScreen="true" [loadingText]="content.loaderText" [type]="'splash'"
        *ngIf="splashEnabled"></app-loaders>
</main>

<section class="payment__process-info">
    <div class="ic-page">
        <h2>{{content.youAreOnPage}}</h2>
        <p class="payment__section-title">{{content.processServices}}</p>
        <section class="payment__process-services">
            <img [width]="31" [height]="20" [src]="'assets/images/tachograf_icon.svg'" [alt]="content.cardAlt">
            <p>{{content.driverLicence}}</p>
            <img [width]="31" [height]="29" [src]="'assets/images/rejestracja_icon.svg'" [alt]="content.vehicleAlt">
            <p>{{content.vehicleRegistration}}</p>
            <img [width]="28" [height]="22" [src]="'assets/images/prawo_jazdy_icon.svg'" [alt]="content.carAlt">
            <p>{{content.dlExam}}</p>
        </section>
        <p class="payment__section-title">{{content.howThisWork}}</p>
        <section class="payment__process-list">
            <ol>
                @for(element of content.processList; track element) {
                <li>{{element}}</li>
                }
            </ol>

            <div class="payment__process-thumb">
                <img [width]="26" [height]="26" [src]="'assets/icons/thumbup.svg'" [alt]="content.thumbAlt">
                <p>{{content.processPayment}}</p>
            </div>
        </section>
    </div>
</section>